import type { SceneConfig } from './sceneConfig';
import { kaabaSceneConfig } from './kaaba';
import { arafatSceneConfig } from './arafat';
import { minaSceneConfig } from './mina';
import { muzdalifaSceneConfig } from './muzdalifa';
import { overallSceneConfig } from './overall';
import { getInsideSceneConfig, isInsideScene } from './insideScenes/registry';

const splatSceneConfigs: Record<string, SceneConfig> = {
  kaaba: kaabaSceneConfig,
  arafat: arafatSceneConfig,
  mina: minaSceneConfig,
  muzdalifah: muzdalifaSceneConfig,
  overall: overallSceneConfig,
};

// Inside-сцены подменяются прозрачно — для App.tsx/SceneCanvas это тоже
// splat-сцены с полноценным конфигом. Отличие только в маршрутизации
// (transient в стеке, кнопка «назад» вместо URL-навигации).
export const getSplatSceneConfig = (id: string): SceneConfig | undefined =>
  splatSceneConfigs[id] ?? getInsideSceneConfig(id);

export const isSplatScene = (id: string): boolean =>
  id in splatSceneConfigs || isInsideScene(id);
